export default __webpack_public_path__ + "static/developer-b06e723c788e1350451c3981d52b6c921a0d8c4d6dba32a35825ce6e2456637d.png";